exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MenuShowStyle_item__30Sge {\n  font-size: 14px;\n  margin: 0;\n  color: #111;\n  text-decoration: none; }\n\n.MenuShowStyle_item__30Sge:hover {\n  color: red; }\n", ""]);

// exports
exports.locals = {
	"item": "MenuShowStyle_item__30Sge"
};